/** Пара label/value в списке `<dl className="info-list">` — карточка клиента (просмотр) и проверка данных в мастере создания. */
export function InfoRow({ label, value }: { label: string; value: string | null }) {
  return (
    <div className="info-list__row">
      <dt>{label}</dt>
      <dd>{value || '–'}</dd>
    </div>
  );
}
